import React, { useState, useCallback } from 'react'
import { Button, TextArea, Loader, Segment, Form, Dimmer, Icon, Checkbox } from 'semantic-ui-react'
import { toast } from "react-toastify";
import Products from '../../Data/Products';
import ReactDatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import APIService from '../../Services/API/APIService';
import * as Yup from "yup";
import { Formik, Field } from 'formik';
import { useDropzone } from "react-dropzone";

const CreateOrder = (prop) => {


    const [loading, setLoading] = useState(false)
    const [checked, setChecked] = useState([])
    const [files, setFiles] = useState([]);
    const onDrop = useCallback((acceptedFiles) => {
        setFiles([...files, ...acceptedFiles]);
    }, [files]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        // accept:"",
        onDrop,
        multiple: false,
    });

    const saveOrder = async (values) => {
        try {
            setLoading(true)

            let formData = new FormData();

            formData.append(`file`, files[0]);
            //Stringify this or experience pain
            formData.append("values", JSON.stringify(values)
            );
           
            if(values.price !== (Number(values.beverage) + Number(values.laundry)
                 + Number(values.food) + Number(values.snack) + Number(values.chinchin))) {
                setLoading(false)
               return  toast.warn('Amount must be equal to total')
            }

            let response = await APIService.postData('/guest-house/saveOrder', formData)
            setLoading(false)
            prop?.toggleOrderModal(false)
            if (response) {
                toast.success('Created succesfully')
            }
        } catch (error) {

            setLoading(false)
            toast.warn("Failed");
        }
    }

    const schema = Yup.object().shape({
        name: Yup.array().of(Yup.string().required('Required')).min(1),
        price: Yup.number().required("Required"),
        date: Yup.date().required("Required"),
        paymentMode: Yup.string().required("Required"),
        description: Yup.string().required("Required"),
        firstname: Yup.string(),
        lastname: Yup.string(),


    });



    const setCheckedId = (i) => {
        if (!checked.find(id => id === i)) {
            setChecked([...checked, i]);
        }
        else {
            setChecked(checked.filter(id => id !== i))

        }
    }

    return (
        <div>

            {loading && (
                <Dimmer active inverted>
                    <Loader />
                </Dimmer>
            )}

            <Segment textAlign="left" loading={loading}>

                <Formik
                    enableReinitialize={true}
                    initialValues={{

                        price: '',
                        date: "",
                        name: checked,
                        paymentMode: '',
                        description: '',
                        firstname: '',
                        lastname: '',
                        beverage: '',
                        laundry: '',
                        food: '',
                        snack: '',
                        chinchin: ''

                    }}
                    validationSchema={schema}
                    onSubmit={saveOrder}
                >
                    {(props) => {
                        const {
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                        } = props;
                        return (
                            <Form onSubmit={handleSubmit}>
                                <Form.Group widths={2}>
                                    <Form.Field>
                                        <label>Products</label>

                                        <Form.Group>
                                            {Products.PRODUCTS?.map((item) => (
                                                <>
                                                    <Checkbox
                                                        name='name'
                                                        key={item.id}
                                                        label={item.name}
                                                        checked={checked.find(id => id === item.value)}
                                                        onChange={(e, f) => setCheckedId(f.value)}
                                                        value={item.name}

                                                    />

                                                </>
                                            ))}

                                        </Form.Group>

                                    </Form.Field>

                                    <Form.Field>
                                        <label>Payment options</label>
                                        <Field
                                            as="select"
                                            name="type"
                                            value={values.paymentMode || ""}
                                            onChange={(value) => {
                                                value.persist();
                                                let item = value.target.value;

                                                props.setFieldValue("paymentMode", item);

                                            }}
                                            error={touched.paymentMode && errors.paymentMode}
                                        >
                                            <option value="" disabled defaultValue hidden>
                                                Select Payment Option
                                            </option>

                                            {Products.PAYMENT_OPTIONS.slice(1, 4).map((item) => (

                                                <option key={item.id} value={item.name}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Field>
                                    </Form.Field>

                                   

                                </Form.Group>


                                <Form.Group widths={4}>

                                    <Form.Input
                                        type='number'
                                        placeholder="Price"
                                        name="price"
                                        label='Price'

                                        value={values.price}
                                        onChange={handleChange}
                                        error={touched.price && errors.price}
                                    />
                                    {checked.find(id => id === Products.PRODUCTS[0].name) && <Form.Input
                                        type='number'
                                        placeholder="Food"
                                        name="food"
                                        label='Food'

                                        value={values.food}
                                        onChange={handleChange}
                                        error={touched.food && errors.food}
                                    />}
                                    {checked.find(id => id === Products.PRODUCTS[1].name) && <Form.Input
                                        type='number'
                                        placeholder="Beverage"
                                        name="beverage"
                                        label='Beverage'

                                        value={values.beverage}
                                        onChange={handleChange}
                                        error={touched.beverage && errors.beverage}
                                    />}
                                    {checked.find(id => id === Products.PRODUCTS[2].name) && <Form.Input
                                        type='number'
                                        placeholder="Laundry"
                                        name="laundry"
                                        label='Laundry'

                                        value={values.laundry}
                                        onChange={handleChange}
                                        error={touched.laundry && errors.laundry}
                                    />
                                    }
                                    {checked.find(id => id === Products.PRODUCTS[3].name) && <Form.Input
                                        type='number'
                                        placeholder="Snacks"
                                        name="snack"
                                        label='Snacks'
                                        value={values.snack}
                                        onChange={handleChange}
                                        error={touched.snack && errors.snack}
                                    />
                                    }
                                    {checked.find(id => id === Products.PRODUCTS[4].name) && <Form.Input
                                        type='number'
                                        placeholder="Chin-Chin"
                                        name="chinchin"
                                        label='Chin-Chin'
                                        value={values.chinchin}
                                        onChange={handleChange}
                                        error={touched.chinchin && errors.chinchin}
                                    />
                                    }

                                    </Form.Group>
                                    <Form.Group widths={4}>
                                    <Form.Input
                                        control={ReactDatePicker}
                                        placeholderText="Select a date"
                                        minDate={dayjs().subtract(1, "day").toDate()}
                                        maxDate={dayjs().toDate()}
                                        label="Date"

                                        selected={
                                            values.date
                                                ? dayjs(values.date).toDate()
                                                : ""
                                        }
                                        onChange={(value) => {
                                            props.setFieldValue("date", value);
                                        }}
                                    />
                                    {values.paymentMode === 'DIRECT_TRANSFER' && (
                                        <>
                                            <Form.Input

                                                placeholder="Firstname"
                                                name="firstname"
                                                label='First Name'

                                                value={values.firstname}
                                                onChange={handleChange}
                                                error={touched.firstname && errors.firstname}
                                            />
                                            <Form.Input

                                                placeholder="Lastname"
                                                name="lastname"
                                                label='Last Name'
                                                value={values.lastname}
                                                onChange={handleChange}
                                                error={touched.lastname && errors.lastname}
                                            />
                                        </>
                                    )}
                                </Form.Group>
                                <Form.Field>
                                        <label>Description</label>
                                        <TextArea
                                            rows={2}
                                            placeholder="description"
                                            name="description"
                                            value={values.description}
                                            onChange={handleChange}
                                            error={touched.description && errors.description}
                                        />


                                    </Form.Field>
                                {values.paymentMode === 'DIRECT_TRANSFER' && (
                                    <div
                                        {...getRootProps()}
                                        style={{
                                            border: "1px dashed black",
                                            marginBottom: "5px",
                                            padding: "10px",
                                        }}
                                    >
                                        <input {...getInputProps()} />
                                        {isDragActive ? (
                                            <p>Drop the file here ...</p>
                                        ) : (
                                            <p>
                                                Drag and drop the payment receipt here, or click to select
                                                file (10MB max)
                                            </p>
                                        )}
                                    </div>)}
                                {files.length !== 0 && (
                                    <div>
                                        <Icon name="file pdf outline" />
                                        {files[0].path}
                                    </div>
                                )}

                                <Button style={{ backgroundColor: '#26f09e', color: '#000000' }} content="Add" loading={loading}
                                    disabled={values.paymentMode === 'DIRECT_TRANSFER' ? files.length < 1 : false} />
                            </Form>
                        );
                    }}
                </Formik>

            </Segment>

        </div>
    )
}

export default CreateOrder